import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { hasClinicAdminAccess, hasSystemAdminAccess, useAuth } from '@/contexts/AuthContext';
import { useLocation } from 'wouter';

type TemplateScope = 'personal' | 'org' | 'system';

const SCOPE_PATHS: Record<TemplateScope, string> = {
  personal: '/templates',
  org: '/templates/org',
  system: '/templates/system',
};

export function TemplateScopeTabs({ active }: { active: TemplateScope }) {
  const { user } = useAuth();
  const [, navigate] = useLocation();
  const canManageOrgTemplates = hasClinicAdminAccess(user);
  const canManageSystemTemplates = hasSystemAdminAccess(user);

  if (!canManageOrgTemplates && !canManageSystemTemplates) {
    return null;
  }

  return (
    <Tabs value={active} onValueChange={(value) => navigate(SCOPE_PATHS[value as TemplateScope])}>
      <TabsList aria-label="Sniðmátaflokkar" className="h-auto flex-wrap justify-start">
        <TabsTrigger value="personal">Mín sniðmát</TabsTrigger>
        {canManageOrgTemplates && <TabsTrigger value="org">Sniðmát stofnunar</TabsTrigger>}
        {canManageSystemTemplates && <TabsTrigger value="system">Kerfissniðmát</TabsTrigger>}
      </TabsList>
    </Tabs>
  );
}
